import React, { useEffect, useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { Vehicle } from "../../../../../types/api/guide/vehicle.types";
import { useFetchPagedVehicle } from "../../../../../hooks/guide/useFetchPagedVehicle";
import { VehicleAddModal } from "../../ui/EntityModal/VehicleAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";
import { useDebouncedValue } from "../../../../../hooks/useDebouncedValue";
import { PagedResultDto } from "../../../../../types/api/PagedResultDto";

interface VehiclesTableProps {
    title: string;
}

export const VehiclesTable = ({ title }: VehiclesTableProps) => {
    const { SnackbarComponent } = useAppSnackbar();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebouncedValue(search, 350);

    useEffect(() => {
        setPage(1);
    }, [debouncedSearch]);

    const { data: paged, isLoading, error, refetch } = useFetchPagedVehicle(
        page,
        pageSize,
        debouncedSearch.trim() || undefined
    );

    const [openModal, setOpenModal] = useState<{ isOpen: boolean; id: string }>({
        isOpen: false,
        id: "",
    });

    const pageData = paged as PagedResultDto<Vehicle> | null | undefined;
    const items = pageData?.items ?? [];
    const totalCount = pageData?.totalCount ?? 0;

    return (
        <>
            <SimpleTable<Vehicle>
                title={title}
                columns={[
                    { key: "number", title: "Номер ТС" },
                    { key: "loadType", title: "Тип загрузки" },
                    { key: "loadCapacity", title: "Грузоподъёмность" },
                    { key: "volume", title: "Объём кузова" },
                    { key: "capacity", title: "Вместимость" },
                    { key: "status", title: "Статус" },
                    { key: "timeWork", title: "Время работы" },
                    { key: "acceptableWasteTypes", title: "Допустимые типы отходов" },
                ]}
                data={items}
                loading={isLoading}
                error={error}
                enableSearchByName
                searchPlaceholder="Поиск по номеру ТС"
                serverPagination={{
                    totalCount,
                    page,
                    pageSize,
                    onPageChange: setPage,
                    onPageSizeChange: (s) => {
                        setPageSize(s);
                        setPage(1);
                    },
                    searchValue: search,
                    onSearchChange: setSearch,
                }}
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenModal({ isOpen: true, id: row.id }),
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, id: "" })}
            />
            {/*
            <ConfirmDialog
                open={!!toDelete}
                title="Удалить транспорт?"
                description={toDelete ? `Будет удалён: ${toDelete.number}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />
            */}

            {openModal.isOpen && (
                <VehicleAddModal
                    id={openModal.id}
                    onClose={() => setOpenModal({ isOpen: false, id: "" })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent />
        </>
    );
};
